import { default as Company } from '.'
import { PageLayout } from '../../../common/app'
import { RouteObject } from 'react-router-dom'

const basePath = '/settings/company'
export const companyRoutes: RouteObject[] = [
  {
    path: `${basePath}/revenue-groups`,
    element: (
      <PageLayout
        title="Report Settings - Revenue Groups"
        displayLeftTitle={false}
      >
        <Company.RevenueGroups.Component />
      </PageLayout>
    ),
    loader: Company.RevenueGroups.Loader,
  },
  {
    path: `${basePath}/preferences`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Company.Preferences.Component />
      </PageLayout>
    ),
    loader: Company.Preferences.Loader,
  },
]
